import { useApi, createApiHook } from "../utils/apiUtils";

const useBulkCreateUsers = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { error, startLoading, setResponse } = useApiState();

  const bulkCreateUsers = async (file) => {
    startLoading();
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiPost("/users/bulk_excel", "Error al cargar usuarios por Excel", formData, { "Content-Type": "multipart/form-data" });
    setResponse(response);
    return response;
  };

  return { bulkCreateUsers, error };
};

export default useBulkCreateUsers;
